<template>
    <div class="dot-container">
        <div v-for="dot in dots" :key="dot" class="dot" :class="stylesFor(dot)" />
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-dots-container')
export default class VrmDotsContainer extends Vue {
    @Prop({ type: Number, default: 0 })
    length;

    get dots() {
        const result = [];
        if (!this.length) return result;
        for (let index = 0; index <= this.length; index++) {
            result.push(index);
        }
        return result;
    }

    stylesFor(dot) {
        return `dot${dot}-${this.length}`;
    }
}
</script>
